import FormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";

import classNames from "classnames";
import styles from "./label.module.scss";

export interface Props extends FormControlLabelProps {
  className?: string;
  hasCheckOrRadiobox?: boolean;
}
function Label(props: Readonly<Props>) {
  const { control, label, className, hasCheckOrRadiobox, ...otherProps } =
    props;

  let cssClasses = {
    [styles.label]: true,
    "sebkort-brand-formlabel": true,
  };
  if (hasCheckOrRadiobox) {
    cssClasses = { ...cssClasses, [styles.radioCheckBox]: true };
  }
  if (className) {
    cssClasses = { ...cssClasses, [className]: true };
  }

  return (
    <FormControlLabel
      control={control}
      label={label}
      className={classNames(cssClasses)}
      {...otherProps}
    />
  );
}

export default Label;
